import React from "react";
import moment from "moment";
import Select from "react-select";

import NumberFormat from "react-number-format";
import { Button } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";

import TableLoader, { TableColumn, TableRow } from "components/Table/Table.js";

import styles from "./style.module.css";

export default class DeploymentRow extends React.PureComponent {
  render() {
    const { deployment, onClick, isHighlight, onHover, history, job, noPermissions } = this.props;

    return (
      <TableRow>
        <TableColumn>
          {noPermissions ? (
            <div onClick={() => onClick()}>{(job && job.name) || deployment.label}</div>
          ) : (
            <a onClick={() => onClick()}>{(job && job.name) || deployment.label}</a>
          )}
        </TableColumn>
        <TableColumn>
          {noPermissions ? (
            <div onClick={() => onClick()}>{deployment.project_id}</div>
          ) : (
            <a onClick={() => onClick()}>{deployment.project_id}</a>
          )}
        </TableColumn>
        <TableColumn title={moment.utc(deployment.created).local().format("MMMM Do YYYY, h:mm:ss a")}>
          {moment.utc(deployment.created).local().fromNow()}
        </TableColumn>
        <TableColumn>{noPermissions ? "No access" : deployment.endpoint_url}</TableColumn>
        <TableColumn>
          <div className={styles.capitalize}>{deployment.status}</div>
        </TableColumn>
      </TableRow>
    );
  }
}
